<template>
  <v-footer dark padless>
    <v-card class="flex" flat tile>
      <!-- <div class="d-flex justify-center teal">
          <v-btn href="https://twitter.com/m_alorwa" target="_blank" class="mx-4" dark icon>
            <v-icon size="24px"> mdi-twitter </v-icon>
          </v-btn>

          <v-btn href="https://instagram.com/m_alorwa" target="_blank" class="mx-4" dark icon>
            <v-icon size="24px"> mdi-instagram </v-icon>
          </v-btn>

          <v-btn href="tel:+96595596920" target="_blank" class="mx-4" dark icon>
            <v-icon size="24px"> mdi-phone </v-icon>
          </v-btn>
        </div> -->
      <v-card-text style="background:#848484;"  class="py-2 white--text text-center">
         <strong>مبرة العروة الوثقى</strong> — {{ new Date().getFullYear() }}
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
footer {
  background-color: #019891;
}
</style>